export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12115.1c1289cb.jpg";